import { render, staticRenderFns } from "./couserView.vue?vue&type=template&id=66bbb1ce&scoped=true"
import script from "./couserView.vue?vue&type=script&lang=js"
export * from "./couserView.vue?vue&type=script&lang=js"
import style0 from "./couserView.vue?vue&type=style&index=0&id=66bbb1ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbb1ce",
  null
  
)

export default component.exports